import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaTransferenciaEnderecoRequest } from './types';

// ACTIONS
import {
	consultaTransferenciaEnderecoSuccess,
	consultaTransferenciaEnderecoFailure,
} from './actions';

function* consultaTransferenciaEndereco(request: ReducerAction) {
	const { payload }: { payload: ConsultaTransferenciaEnderecoRequest } =
		request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`transferencia-endereco/${CHANNEL}/consulta`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaTransferenciaEnderecoSuccess({ response, payload }));
	} else if (response.error) {
		yield put(consultaTransferenciaEnderecoFailure(response.error));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_TRANSFERENCIA_ENDERECO,
		consultaTransferenciaEndereco,
	),
]);
